export default (theme) => ({
    root: {},
});
